import { Component } from '@angular/core';
import { NavController, NavParams, ModalController, Events, Platform } from 'ionic-angular';
import { LocalNotifications } from '@ionic-native/local-notifications';
import { ConfigProvider } from '../../providers/config/config';
import { Storage } from '@ionic/storage';
import { Http } from '@angular/http';
import { PrivacyPolicyPage } from '../privacy-policy/privacy-policy';
import { TermServicesPage } from '../term-services/term-services';
import { FinanceOptionsPage } from '../finance-options/finance-options';
import { SubAccountsPage } from '../subaccount/subaccount';
import { CreateSubAccountsPage } from '../create-subaccount/create-subaccount';
import { EmailTemplatePage } from '../email-template/email-template';
import { SubscriptionsPage } from '../subscriptions/subscriptions';
import { HighLevelPage } from '../highlevel/highlevel';



import { RefundPolicyPage } from '../refund-policy/refund-policy';
import { PaymentsPage } from '../payments/payments';
import { LoadingProvider } from '../../providers/loading/loading';
import { SharedDataProvider } from '../../providers/shared-data/shared-data';
import { LoginPage } from '../login/login';
import { MyAccountPage } from '../my-account/my-account';
import { InAppBrowser } from '@ionic-native/in-app-browser';
import { CartPage } from '../cart/cart';
import { SearchPage } from '../search/search';
import { SocialSharing } from '@ionic-native/social-sharing';
import { AppVersion } from '@ionic-native/app-version';
import { Pro } from '@ionic/pro';
import { RelativeTimePipe } from '../../pipes/relative-time/relative-time';
import { Deploy } from 'cordova-plugin-ionic/dist/ngx';


@Component({
  selector: 'page-settings',
  templateUrl: 'settings.html',
})
export class SettingsPage {
  setting: { [k: string]: any } = {};
  versionNumber = '---';
  public deployChannel = "";
  public isBeta = false;
  public downloadProgress = 0;
APRRate = "";

  constructor(
    public platform: Platform,
    public navCtrl: NavController,
    public navParams: NavParams,
    public modalCtrl: ModalController,
    public config: ConfigProvider,
    private storage: Storage,
    public loading: LoadingProvider,
    public http: Http,
    private localNotifications: LocalNotifications,
    public events: Events,
    public shared: SharedDataProvider,
    public iab: InAppBrowser,
    private socialSharing: SocialSharing,
    public plt: Platform,
    private appVersion: AppVersion,
    private deploy: Deploy
  ) {
    this.checkChannel();
  }

  async checkChannel() {
    try {
      const res = await Pro.deploy.getConfiguration();
      this.deployChannel = res.channel;
      this.isBeta = (this.deployChannel === 'Beta')
    } catch (err) {
      // We encountered an error.
      // Here's how we would log it to Ionic Pro Monitoring while also catching:

    }
  }

  async toggleBeta() {
    const config = {
      channel: (this.isBeta ? 'Beta' : 'Master')
    }

    try {
      await Pro.deploy.configure(config);
      await this.checkChannel();
      await Pro.deploy.sync({updateMethod: 'background'}); // Alternatively, to customize how this works, use performManualUpdate()
    } catch (err) {
      // We encountered an error.
      // Here's how we would log it to Ionic Pro Monitoring while also catching:


    }

  }

  openhighlevelSetup = function (){
    console.log("Open Subscription:",this.shared.customerData);
    this.navCtrl.push(HighLevelPage);

  }

  opensubscription = function (){
    console.log("Open Subscription:",this.shared.customerData);
    this.navCtrl.push(SubscriptionsPage);

  }

  openEmailTemplatePage = function(){

    this.navCtrl.push(EmailTemplatePage);
  }

    openFinancePage = function (){
    console.log("Open Finance Page");
    this.navCtrl.push(FinanceOptionsPage);
  }

  changeInRate(value)
  {
    var data: { [k: string]: any } = {};
    data.customers_id = this.shared.customerData.customers_id;
    console.log("CHange in APR Rate:",this.APRRate);
console.log("Customer Info:",this.shared.customerData);
    if(this.APRRate == "0")
    {
      this.showModal("Test");
    }
    data.desired_APR=this.APRRate;

  //  console.log("Data to Post:",JSON.stringify(data));
    this.http.post(this.config.url + 'updateCustomerAPR', data).map(res => res.json()).subscribe(data => {
        //this.loading.hide();

    });

  }


  turnOnOffNotification(value) {
    if (this.setting.localNotification == false) {
      this.localNotifications.cancel(1).then((result) => {
      });
    }
    else {
      this.localNotifications.schedule({
        id: 1,
        title: this.config.notifTitle,
        text: this.config.notifText,
        every: this.config.notifDuration,
      });
    }

    this.updateSetting();
  }

  updateSetting() {
    console.log(this.setting);
    this.storage.set('setting', this.setting);
  }
  openLoginPage() {
    let modal = this.modalCtrl.create(LoginPage);
    modal.present();
  }
  logOut() {
    this.shared.logOut();
  }

  opensubscriptionPage(){
    this.navCtrl.push(PaymentsPage);
  }

  opensubaccountPage(){
    this.navCtrl.push(SubAccountsPage);
    //this.navCtrl.push(CreateSubAccountsPage);

  }

  openPage(page) {
    if (page == 'myAccount') this.navCtrl.push(MyAccountPage);
  }
  openSite() {
    this.loading.autoHide(2000);
    this.iab.create(this.config.siteUrl, "blank");
  }
  //============================================================================================
  //turning on off local  notification
  onOffPushNotification() {
    this.storage.get('registrationId').then((registrationId) => {
      var data: { [k: string]: any } = {};
      data.device_id = registrationId;
      if (this.setting.notification == false) data.is_notify = 0;
      else data.is_notify = 1;
      this.http.post(this.config.url + 'notify_me', data).map(res => res.json()).subscribe(data => {
        if (data.success == 1) {

          this.updateSetting();
        }
      }, function (response) {
        console.log(response);
      });
    });
  };
  hideShowFooterMenu() {
    this.events.publish('setting', this.setting);
    this.updateSetting();
  }
  hideShowCartButton() {
    this.events.publish('setting', this.setting);
    this.updateSetting();
  }
  showModal(value) {
    this.loading.autoHide(1000);
    if (value == 'privacyPolicy') {
      let modal = this.modalCtrl.create(PrivacyPolicyPage);
      modal.present();
    }
    else if (value == 'termServices') {
      let modal = this.modalCtrl.create(TermServicesPage);
      modal.present();
    }
    else {
      let modal = this.modalCtrl.create(RefundPolicyPage);
      modal.present();
    }
  }


  ionViewDidLoad() {
    this.storage.get('setting').then((val) => {
      if (val != null || val != undefined) {
        this.setting = val;
      }
      else {
        this.setting.localNotification = true;
        this.setting.notification = true;
        this.setting.cartButton = true;
        this.setting.footer = true;
        this.setting.defaultAPR= '2';
      }

      this.APRRate =   this.setting.defaultAPR;
    });


    //Get custom configs for this customer
    var data: { [k: string]: any } = {};
    data.customers_id = this.shared.customerData.customers_id;

    this.http.post(this.config.url + 'getCustomerAPR', data).map(res => res.json()).subscribe(data => {
        //this.loading.hide();
      if (data.success == 1) {
        this.APRRate  = data.data.financeOption;
      //  console.log("Customer APR:",data.data.financeOption);
				//console.log("Got  Response:",JSON.stringify(data));
      }
    });



    if(this.platform.is('core') || this.platform.is('mobileweb')) {
      console.log("Platform is core or is mobile web");
      this.versionNumber = "Web (Web:4.0)";
    } else {
      this.appVersion.getVersionNumber().then((s) => {
        this.versionNumber = s + '.202';
      })
}


  }

  openCart() {
    this.navCtrl.push(CartPage);
  }
  openSearch() {
    this.navCtrl.push(SearchPage);
  }
  rateUs() {
    this.loading.autoHide(2000);
    if (this.plt.is('ios')) {
      this.iab.create(this.config.packgeName.toString(), "_system");
    } else if (this.plt.is('android')) {
      this.appVersion.getPackageName().then((val) => {
        this.iab.create("https://play.google.com/store/apps/details?id=" + val, "_system");
      });
    }
  }
  share() {
    this.loading.autoHide(2000);
    if (this.plt.is('ios')) {
      this.socialSharing.share(
        this.config.packgeName.toString(),
        this.config.appName,
        this.config.packgeName.toString(),
        this.config.packgeName.toString()
      ).then(() => {
      }).catch(() => {

      });
    } else if (this.plt.is('android')) {

      this.appVersion.getPackageName().then((val) => {
        this.socialSharing.share(
          this.config.appName,
          this.config.appName,
          "",
          "https://play.google.com/store/apps/details?id=" + val
        ).then(() => {

        }).catch(() => {
        });
      });
    }
  }
  showAd() {
    this.loading.autoHide(2000);
    this.events.publish('showAd');
  }
}



// WEBPACK FOOTER //
// ./src/pages/settings/settings.ts